export default __webpack_public_path__ + "static/media/2347.90d1eac2.png";